import React from 'react';
import { observer, inject } from 'mobx-react';

import { BlockList, BlockListProps } from './BlockList';
import { EntryPage as EntryPageStore } from '@patient/ui/shared/store';

interface Props extends BlockListProps {}

interface StoreProps {
    entryPage: EntryPageStore;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const {
            entryPage: { rightContentMenu },
        } = this.props;

        const blockIndexes = rightContentMenu.itemsKeys;

        return React.createElement(BlockList, {
            blockIndexes,
        });
    }
}

export const BlockListContainer = inject<Props, StoreProps>(EntryPageStore.Name)(Component);
